import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {useAppSelector} from "../../redux/hooks";
import {Theme} from "@mui/material";
import AppBar from "../../components/appBar";
import Strings from "../../assets/strings";
const useStyles = makeStyles((theme:Theme) => ({
    h1:{
        textTransform: "uppercase",
        textAlign: "center",
        color: theme.palette.secondary.main,
        paddingTop: "7%",
        [theme.breakpoints.down('md')]: {
            fontSize: "1.3em",
        }
    },
}));
export default function DashBoard() {
    const {user} = useAppSelector(state => state.auth)
    const classes = useStyles();
    return (
        <>
            <AppBar title={Strings.inicio}/>

            <div className={"contentInner"}>
                <div>
                    <h1 className={classes.h1}>Bienvenido, {user?.nombre}</h1>
                </div>
            </div>
        </>
    )
}

